import { useState } from "react";

/**
 * Checkbox-style toggle.
 * Seeded once from `initialState` on mount, updated on each toggle; `onToggle` fires with the new value.
 * Optional: pass `checked` for controlled usage when the parent must own the value (e.g. async data).
 */
const ToggleSwitch = ({
  label,
  onToggle,
  initialState = false,
  checked,
  disabled = false,
  "aria-label": ariaLabel,
  ariaLabel: camelAriaLabel,
}) => {
  const isControlled = checked !== undefined;
  const [internalOn, setInternalOn] = useState(initialState);
  const isOn = isControlled ? Boolean(checked) : internalOn;
  const accessibleName = ariaLabel || camelAriaLabel || label;

  const handleToggle = () => {
    if (disabled) {
      return;
    }
    const newState = !isOn;
    if (!isControlled) {
      setInternalOn(newState);
    }
    if (onToggle) {
      onToggle(newState);
    }
  };

  return (
    <div className="toggle-switch-container">
      {label && <span className="toggle-switch-label">{label}</span>}
      <label className="toggle-switch">
        <input
          type="checkbox"
          checked={isOn}
          disabled={disabled}
          onChange={handleToggle}
          className="toggle-switch-checkbox"
          role="switch"
          aria-checked={isOn}
          aria-label={accessibleName}
        />
        <span className="toggle-switch-slider round"></span>
      </label>
    </div>
  );
};

export default ToggleSwitch;
